module.exports = __webpack_public_path__ + "static/images/map/no_track_info.png";